import { useEffect, useRef, useState } from "react";
import { DateRangePicker } from "react-date-range";
import moment from "moment";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const CommonDateRangePicker = ({
  searchFilter,
  setSearchFilter,
  initialStartDate,
  initialEndDate,
}) => {
  const [rangepicker, setRange] = useState([
    {
      startDate: initialStartDate,
      endDate: initialEndDate,
      key: "selection",
    },
  ]);
  const [open, setOpen] = useState(false);
  const [isDesktop, setDesktop] = useState(window.innerWidth > 991);
  const refOne = useRef(null);

  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setOpen(false);
    }
  };

  const updateMedia = () => {
    setDesktop(window.innerWidth > 991);
  };
  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });

  useEffect(() => {
    const startDateFormat = moment(rangepicker[0]?.startDate).format(
      "YYYY-MM-DD"
    );
    const endDateFormat = moment(rangepicker[0]?.endDate).format("YYYY-MM-DD");
    const range = [
      { ...rangepicker[0], startDate: startDateFormat, endDate: endDateFormat },
    ];
    document.addEventListener("click", hideOnClickOutside);
    setSearchFilter({
      ...searchFilter,
      startDate: range?.[0]?.startDate,
      endDate: range?.[0]?.endDate,
    });
  }, [rangepicker[0]?.startDate, rangepicker[0]?.endDate]);
  return (
    <div className="calendarWrap" style={{ cursor: "pointer" }}>
      <div
        id="daterange"
        className="selectbox pull-right"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!open);
        }}
      >
        <input
          placeholder="Duration Date"
          className="daterangeinput daterangeinputappoinment"
          onChange={() => {}}
          value={
            searchFilter?.startDate === null ||
            searchFilter?.endDate === null ||
            searchFilter?.startDate === "Invalid date"
              ? ""
              : `${moment(searchFilter?.startDate).format(
                  "DD/MM/YYYY"
                )} - ${moment(searchFilter?.endDate).format("DD/MM/YYYY")}`
          }
        />
        <i className="fa-solid fa-caret-down"></i>
      </div>

      <div ref={refOne}>
        {open && (
          <DateRangePicker
            onClickOutside={() => setOpen(true)}
            onChange={(item) => {
              setRange([item.selection]);
            }}
            editableDateInputs={true}
            moveRangeOnFirstSelection={false}
            ranges={rangepicker}
            months={2}
            direction={isDesktop ? "horizontal" : "vertical"}
            className="calendarElement appoinmentcalendarElement"
            showSelectionPreview={true}
          />
        )}
      </div>
    </div>
  );
};

export default CommonDateRangePicker;
